import { toast } from 'react-toastify'
import hospitalServices from './hospital.services'
import schoolServices from './school_services'
import store from '../store'
import { set,get } from 'automate-redux'

export function SetPageTittle(data) {

    localStorage.setItem('PageTittle', data.tittle)

}

export function GetPageTittle(data) {

    return localStorage.getItem('PageTittle')

}


export function SetUserDetailsToLocal(data) {

    data.token &&  localStorage.setItem("token", data.token)
    localStorage.setItem("user", JSON.stringify(data.user))
    localStorage.setItem("type", JSON.stringify(data.is_auth_sub_admin))
}

export function getUserDetailsfromLocal() {

    return  localStorage.getItem("user")
}

export function showSuccessMessage(obj) {
    toast.success(obj.message, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}

export function showErrorMessage(obj) {
    toast.error(obj.message, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}

export function handleLoadingBar(status){
    store.dispatch(set("loadingbar",status ))
}

export function getSchoolSharedDoc(obj) {
    return new Promise(async (resolve, reject) => {

        try {
            const resp = await schoolServices.getSharedDoc(obj);
            window.open(resp.data.data.signedUrl);
            resolve(resp)
        } catch (err) {
            reject(err)
        }

    })
}

export function getHospitalSharedDoc(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await hospitalServices.getFilesData(obj);
            window.open(resp.data.signedUrl);
            resolve(resp)
        } catch (err) {
            reject(err)
        }

    })
}

export function validatePassword(pass) {
        try {
            const re = /^(?=.*\d)(?=.*[a-z])(?=.*[^a-zA-Z0-9])(?!.*\s).{7,15}$/
            return re.test(pass)
        } catch (err) {
        }
}



